import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { connect } from 'react-redux';
import classnames from 'classnames';
import * as ActionTypes from '../../../constants/ActionTypes';

class FormFieldDisplayedOrRequired extends Component {
    changeFieldOption = fieldType => {
        const { changeDisplayedFields, changeRequiredFields, formType, fieldCode, toggleConfigBoolean } = this.props;

        if (formType === 'guestDetails' && fieldCode === 'loyaltyProgram') {
            return toggleConfigBoolean('enableLoyaltyProgramTypes', this.props.enableLoyaltyProgramTypes);
        } else if (fieldType === 'displayed') {
            return changeDisplayedFields(formType, fieldCode);
        } else {
            return changeRequiredFields(formType, fieldCode);
        }
    };

    shouldRenderIsRequiredOptionalButton = (fieldCode, isVisible) => {
        if (fieldCode === 'cvvCode') {
            return isVisible;
        }

        return !['comments', 'emailOptIn', 'loyaltyProgram', 'paymentInfo'].includes(fieldCode);
    };

    render() {
        const { fieldCode, displayedFields, isDisabled, requiredFields, show, formType } = this.props;
        const isVisible =
            displayedFields.includes(fieldCode) ||
            requiredFields.includes(fieldCode) ||
            (fieldCode === 'loyaltyProgram' && formType === 'guestDetails' && this.props.enableLoyaltyProgramTypes);
        const isRequired = requiredFields.includes(fieldCode) || fieldCode === 'cvvCode';

        const disabledDisplayedFields = ['firstName', 'emailAddress', 'lastName'];
        const disabledRequiredFields = ['cvvCode', 'emailAddress', 'firstName', 'lastName'];

        const shouldDisableDisplayedField = disabledDisplayedFields.includes(fieldCode);
        const shouldDisabledRequiredField = disabledRequiredFields.includes(fieldCode);

        const shouldRenderRequiredButton = this.shouldRenderIsRequiredOptionalButton(fieldCode, isVisible);

        if (!show) {
            return null;
        }

        return (
            <div className="displayed-required-buttons">
                <button
                    className={classnames('spark-icon-password-view', 'spark-icon-lg', { active: isVisible })}
                    disabled={isDisabled || (shouldDisableDisplayedField && isVisible)}
                    onClick={this.changeFieldOption.bind(this, 'displayed')}
                    type="button"
                >
                    {isVisible ? 'Visible' : 'Not Visible'}
                </button>
                {shouldRenderRequiredButton && (
                    <button
                        className={classnames('spark-icon-password-view', 'spark-icon-lg', { active: !isRequired })}
                        disabled={
                            isDisabled || (shouldDisabledRequiredField && isRequired) || fieldCode === 'dateOfBirth'
                        }
                        onClick={this.changeFieldOption.bind(this, 'required')}
                        type="button"
                    >
                        {isRequired ? 'Required' : 'Optional'}
                    </button>
                )}
            </div>
        );
    }
}

FormFieldDisplayedOrRequired.defaultProps = {
    displayedFields: [],
    requiredFields: [],
    show: false
};

FormFieldDisplayedOrRequired.propTypes = {
    changeDisplayedFields: PropTypes.func.isRequired,
    changeRequiredFields: PropTypes.func.isRequired,
    displayedFields: PropTypes.arrayOf(PropTypes.string),
    fieldCode: PropTypes.string.isRequired,
    formType: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool.isRequired,
    requiredFields: PropTypes.arrayOf(PropTypes.string),
    show: PropTypes.bool
};

const mapStateToProps = (state, props) => ({
    enableLoyaltyProgramTypes: get(
        state,
        'app.data.configuration.configuration.currentConfigCopy.enableLoyaltyProgramTypes',
        false
    ),
    displayedFields: get(
        state,
        `app.data.configuration.configuration.currentConfigCopy.displayedFields[${props.formType}]`,
        []
    ),
    requiredFields: get(
        state,
        `app.data.configuration.configuration.currentConfigCopy.requiredFields[${props.formType}]`,
        []
    )
});

const mapDispatchToProps = dispatch => ({
    toggleConfigBoolean: (code, value) => {
        dispatch({ type: ActionTypes.TOGGLE_BOOLEAN_VALUE_IN_CONFIG, code, value });
    },
    changeDisplayedFields: (formName, fieldCode) => {
        dispatch({ type: ActionTypes.CHANGE_FIELDS });
        dispatch({
            type: ActionTypes.CHANGE_DISPLAYED_FIELDS,
            fieldCode,
            formName
        });
    },
    changeRequiredFields: (formName, fieldCode) => {
        dispatch({ type: ActionTypes.CHANGE_FIELDS });
        dispatch({
            type: ActionTypes.CHANGE_REQUIRED_FIELDS,
            fieldCode,
            formName
        });
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(FormFieldDisplayedOrRequired);



// WEBPACK FOOTER //
// ./src/components/widgets/TableFormFields/FormFieldDisplayedOrRequired.js